package com.exura.common.domain.validation.email

import com.exura.common.domain.validation.StringValidationState

object EmailValidator {

    fun validateEmail(email: String): StringValidationState =
        when {
            email.isBlank() -> StringValidationState.Error.Empty
            !Regex(EMAIL_REGEX).matches(email.trim()) -> StringValidationState.Error.Invalid
            else -> StringValidationState.Success
        }

    private const val EMAIL_REGEX = """^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}${'$'}"""
}
